import { StyledTextField } from "@Components/common/byb-ds/input/styled-components";
import { Box, TextFieldProps, useTheme } from "@mui/material";

interface IBybTextField {
  readOnly?: boolean;
  hasValue?: boolean;
}

const BybTextField = ({ readOnly = false, hasValue = false, value, ...props }: TextFieldProps & IBybTextField) => {
  const theme = useTheme();

  return (
    <Box sx={{ position: "relative", isolation: "isolate" }}>
      <StyledTextField
        value={value}
        aria-readonly={readOnly}
        sx={{
          "& .MuiFilledInput-root": {
            backgroundColor: theme.palette.dsSurface.v200,
          },
          ...((!!value || hasValue) && {
            "& .MuiFilledInput-root": {
              backgroundColor: theme.palette.dsBase.v100,
              borderColor: theme.palette.mode === "light" ? theme.palette.dsSurface.v400 : theme.palette.dsSurface.v200,
            },
          }),
        }}
        {...props}
      />
      {readOnly && <Box sx={{ position: "absolute", inset: 0, zIndex: 1, pointerEvents: "auto" }} />}
    </Box>
  );
};

export default BybTextField;
